import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Grid,
  Select,
  TextField,
  Button,
  Box,
  Paper,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddMasterTopic = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [lessonId, setLessonId] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [topicName, setTopicName] = useState("");
  const [topicContent, setTopicContent] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [classData, setClassData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [lessonData, setLessonData] = useState([]);
  let navigate = useNavigate();

  const fetchClasses = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching classes: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setClassData(data);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching classes.");
      setSnackbarMessage('An error occurred while fetching classes.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")

    }
  };

  const fetchSubjects = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Question/ddlSubject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching subjects: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setSubjectData(data);
      } else {
        setSubjectData([]);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching subjects.");
       setSnackbarMessage('An error occurred while fetching subjects.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchLessons = async (classId, subjectId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Question/ddlLession`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId, subjectId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching lessons: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setLessonData(data);
      } else {
        setLessonData([]);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching lessons.");
       setSnackbarMessage('An error occurred while fetching lessons.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleClassChange = (event) => {
    const selectedClassId = event.target.value;
    setClassId(selectedClassId);
    setSubjectId("");
    setLessonId("");
    setSubjectData([]);
    setLessonData([]);
    if (selectedClassId) {
      fetchSubjects(selectedClassId);
    }
  };

  const handleSubjectChange = (event) => {
    const selectedSubjectId = event.target.value;
    setSubjectId(selectedSubjectId);
    setLessonId("");
    setLessonData([]);
    if (selectedSubjectId && classId) {
      fetchLessons(classId, selectedSubjectId);
    }
  };

  const handleReset = () => {
    setClassId("");
    setSubjectId("");
    setLessonId("");
    setVideoLink("");
    setTopicName("");
    setTopicContent("");
    setPdfFile(null);
    setSubjectData([]);
    setLessonData([]);
  };

  const validateInputs = () => {
    if (!classId) {
      setErrorMessage("Please select a Class.");
      return false;
    }
    if (!subjectId) {
      setErrorMessage("Please select a Subject.");
      return false;
    }
    if (!lessonId) {
      setErrorMessage("Please select a Lesson.");
      return false;
    }
    if (!topicName.trim()) {
      setErrorMessage("Please enter a Topic Name.");
      return false;
    }
    if (!topicContent.trim()) {
      setErrorMessage("Please enter Topic Content.");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateInputs()) {
      setShowErrorModal(true);
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const formData = new FormData();
      formData.append("ClassId", classId);
      formData.append("SubjectId", subjectId);
      formData.append("TopicName", topicName);
      formData.append("LessionId", lessonId);
      formData.append("TopicContent", topicContent);
      formData.append("VideoLink", videoLink || "empty");
      if (pdfFile) {
        formData.append("PdfPath", pdfFile);
      }

      const response = await fetch(`${apiUrl}/OfflineTopicMaster`, {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      if (!response.ok) {
        // alert(`Error posting data: ${response.status}`);
         setSnackbarMessage(`Error posting data: ${response.status}`);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      } else {
        setShowSuccessModal(true);
        handleReset();
      }
    } catch (error) {
      // alert(error);
       setSnackbarMessage(error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  return (
    <div>
      <Container>
        <Box
          sx={{
            backgroundColor: "#0B1F40",
            padding: "12px 24px",
            boxShadow: 3,
            borderRadius: "4px 4px 0 0",
            margin: "2px auto",
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ color: "#fff", fontWeight: "bold" }}>
            Add Topic
          </Typography>
        </Box>
        <Paper
          elevation={3}
          style={{ padding: 16, width: "100%", margin: "auto", marginTop: 6 }}
        >
          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="classId">Class</InputLabel>
                <Select
                  value={classId}
                  onChange={handleClassChange}
                  label="Class"
                  id="classId"
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {classData.map((item) => (
                    <MenuItem key={item.classId} value={item.classId}>
                      {item.className}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="subjectId">Subject</InputLabel>
                <Select
                  value={subjectId}
                  onChange={handleSubjectChange}
                  label="Subject"
                  id="subjectId"
                  disabled={!classId}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {subjectData.map((item) => (
                    <MenuItem key={item.subjectId} value={item.subjectId}>
                      {item.subjectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="lessonId">Lesson</InputLabel>
                <Select
                  value={lessonId}
                  onChange={(e) => setLessonId(e.target.value)}
                  label="Lesson"
                  id="lessonId"
                  disabled={!subjectId}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {lessonData.map((item) => (
                    <MenuItem key={item.lessionId} value={item.lessionId}>
                      {item.lessionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Video Link"
                value={videoLink}
                onChange={(e) => setVideoLink(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Topic Name"
                value={topicName}
                onChange={(e) => setTopicName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Topic Content"
                value={topicContent}
                onChange={(e) => setTopicContent(e.target.value)}
                multiline
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Button variant="contained" component="label" startIcon={<Add />}>
                Upload PDF
                <input
                  type="file"
                  accept="application/pdf"
                  hidden
                  onChange={(e) => setPdfFile(e.target.files[0])}
                />
              </Button>
              {pdfFile && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected: {pdfFile.name}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
                marginRight: "10px",
              }}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleReset}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
                marginRight: "10px",
              }}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCancel}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Paper>
      </Container>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          <Box sx={{ backgroundColor: "#0B1F40", padding: "12px 16px" }}>
            <Typography
              id="success-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Topic Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Topic has been added successfully.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          <Box sx={{ backgroundColor: "#d32f2f", padding: "12px 16px" }}>
            <Typography
              id="error-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Missing Required Field ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <Typography id="error-modal-description" sx={{ mb: 2 }}>
              {errorMessage}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => setShowErrorModal(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </div>
  );
};

export default AddMasterTopic;
